export default "__VITE_ASSET__89087335__"